import apiService from '../../apiService'
import Notification from '../../notification'

export default {
  namespaced: true,
  state: {
    manager: {
      id: null,
      name: '',
      email: '',
      mobilePhone: '',
      innerPhone: '',
      addPhones: [],
      main: null,
      photo: ''
    },
    paramsProviders: {}
  },
  mutations: {
    setManager (state, manager) {
      state.manager.id = manager.id
      state.manager.name = manager.name
      state.manager.email = manager.email
      state.manager.mobilePhone = manager.mobile_phone
      state.manager.innerPhone = manager.inner_phone
      state.manager.addPhones = manager.add_phone
      state.manager.main = manager.main
      state.manager.photo = manager.photo
    },
    addParamsProvider (state, { name, callback }) {
      state.paramsProviders[name] = callback
    },
    clear (state) {
      state.manager.id = null
    }
  },
  actions: {
    fetch ({ state, commit }, module) {
      commit('clear')

      const paramsProvider = state.paramsProviders[module]

      const params = paramsProvider ? paramsProvider() : null

      if (params) {
        apiService.getManager(module, params)
          .then(response => {
            commit('setManager', response.data.manager)
          })
          .catch(() => {
            Notification.notifyError({
              title: 'Ошибка',
              content: 'Не удалось загрузить информацию о менеджере.'
            })
          })
      }
    }
  },
  getters: {
    mainOrNotText: (state) => state.manager.main ? 'персональный' : 'замещающий',
    addPhonesText: (state) => state.manager.addPhones ? state.manager.addPhones.join(', ') : '',
    isLoaded: (state) => !!state.manager.id
  }
}
